

export default () => {
    $('.filter .filter-selected-option, .filter .icon').off('click').click(function() {
        $(this).parents('.filter').find('.filter-option-list').slideToggle();
        $(this).parents('.filter').toggleClass('active');
    });

    $('.filter .filter-option').off('click').click(function() {
        $(this).parents('.filter').find('.filter-option-list').slideUp();
        $(this).parents('.filter').removeClass('active');
        $(this).parents('.filter').find('.filter-selected-option').text($(this).text());
    });
}
